import React, { memo } from "react";
import { useParams } from "react-router-dom";
import { PageTemplate } from "../../../components/templates";
import { OUTPUT } from "../../../enums";
import EnquadramentoEdit from "../_components/EnquadramentoEdit";
import CenarioEdit from "../_components/CenarioEdit";

const ReportSettingsEdit = memo(() => {
  const params = useParams();

  const OUTPUTS = {
    enquadramento: EnquadramentoEdit,
    stresstest: CenarioEdit,
  };

  const EditComponent = OUTPUTS[params.output];
  const { title, subtitle } = OUTPUT[params.output].config_edit;

  return (
    <PageTemplate
      title={title}
      subtitle={subtitle}
      scrollable={false}
      maxWidth="md"
    >
      <EditComponent />
    </PageTemplate>
  );
});

export default ReportSettingsEdit;
